import { Api } from '../api';
const contentTypeApplicationJson = { 'Content-Type': 'application/json' };
const contentTypeUrlEncoded = { 'Content-Type': 'application/x-www-form-urlencoded' };
export function FetchApi(options) {
    const { baseUrl, key, onError, onUnauthorized } = options || {};
    const apiHeader = key ? { 'X-api-key': key } : undefined;
    const processApiResponse = (toJson) => {
        return async (response) => {
            if (response.ok) {
                return {
                    payload: toJson ? await response.json() : null,
                    response: response,
                };
            }
            if (response.status === 401) {
                if (onUnauthorized) {
                    onUnauthorized();
                    return null;
                }
            }
            throw new Error(`Api returned status code ${response.status} - ${response.statusText}`);
        };
    };
    const get = (url, options) => {
        return fetch(url, {
            method: options?.method ?? 'GET',
            headers: {
                ...apiHeader,
                ...options?.headers,
            },
            signal: options?.abortSignal,
        }).then(processApiResponse(!options?.nativeProcessing));
    };
    const post = (url, data, options) => {
        const { body, header } = getPostPayload(data, options);
        return fetch(url, {
            method: options?.method ?? 'POST',
            headers: {
                ...apiHeader,
                ...options?.headers,
                ...header,
            },
            body: body,
            signal: options?.abortSignal,
        }).then(processApiResponse(!options?.nativeProcessing));
    };
    return new Api({
        makeGetCall: get,
        makePostCall: post,
        baseUrl,
        onError,
    });
}
function getPostPayload(data, options) {
    if (options?.noStringify || options?.mode === 'raw') {
        return {
            header: {},
            body: data,
        };
    }
    else if (options?.mode === 'x-www-form-urlencoded') {
        return {
            header: contentTypeUrlEncoded,
            body: Object.entries(data)
                .map(([key, value]) => encodeURIComponent(key) + '=' + encodeURIComponent(value))
                .join('&'),
        };
    }
    else {
        return {
            header: contentTypeApplicationJson,
            body: JSON.stringify(data),
        };
    }
}
